import { Facebook, Instagram, LinkedIn, Twitter, Location, Mail, Call, Time, Teeth } from '../../../Assets/SVGS';
import { useTranslation } from 'react-i18next';
import './Footer.css'
function Footer(){
  const { t } = useTranslation();
  const date = new Date()
  return (
    <>
      <footer className='footer-container'>
        <div className='footer-content content'>
          <div className="footer-main">
            <div className="footer-about">
              <div className="footer-logo">
                <span className="logo-icon"><Teeth width="26px" /></span>
                <h2>{t('clinicName')}</h2>
              </div>
              <p className="about-desc">{t('clinicDesc')}</p>
              <ul className="social-icons">
                <li>
                  <a href='https://www.facebook.com/share/1WT384W32D/' target='_blank' rel="noreferrer"><Facebook width="18px" /></a>
                </li>
                <li>
                  <a href='https://www.instagram.com/dr.markatefdentalclinic/' target='_blank' rel="noreferrer"><Instagram width="18px" /></a>
                </li>
                <li>
                  <a href='https://www.instagram.com/dr.markatefdentalclinic/' target='_blank' rel="noreferrer"><LinkedIn width="18px" /></a>
                </li>
                <li>
                  <a href='https://www.instagram.com/dr.markatefdentalclinic/' target='_blank' rel="noreferrer"><Twitter width="18px" /></a>
                </li>
              </ul>
            </div>

            <div className="footer-col">
              <h3>{t('quickLinks')}</h3>
              <ul className="quick-links">
                <li><a href="/">{t('home')}</a></li>
                <li><a href="/about">{t('about')}</a></li>
                <li><a href="/doctors">{t('doctors')}</a></li>
                <li><a href="/services">{t('services')}</a></li>
                <li><a href="/contact-us">{t('contactUs')}</a></li>
              </ul>
            </div>

            <div className="footer-col">
              <h3>{t('contactInfo')}</h3>
              <ul className="contact-info">
                <li><span className="contact-icon"><Location width="18px" /></span><span>{t('addressFooter')}</span></li>
                <li><span className="contact-icon"><Call width="18px" /></span><span>{t('phoneFooter')}</span></li>
                <li><span className="contact-icon"><Mail width="18px" /></span><span>{t('email')}</span></li>
              </ul>
            </div>

            <div className="footer-col">
              <h3>{t('openingHours')}</h3>
              <ul className="work-hours">
                <li>
                  <span className="contact-icon"><Time width="18px" /></span>
                  <span>{t('satTue')}</span>
                </li>
                <li>
                  <span className="contact-icon"><Time width="18px" /></span>
                  <span className="closed">{t('fridayClosed')}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="copyRight">
          <p>{t('designedWith')} &copy; 2025 - {date.getFullYear()}</p>
        </div>
      </footer>
    </>
  );
}
export default Footer
